export default {
  init() {
    const videoPlay = document.querySelector('.js-video-play');
    const video = document.querySelector('video');
    const wrap = document.querySelector('.js-video-wrap');
    if (videoPlay) {
      videoPlay.addEventListener('click', () => {
        wrap.classList.add('video-is-playing');
        video.play();
      });
    }

    if (video) {
      video.addEventListener('ended', () => {
        wrap.classList.remove('video-is-playing');
      });
    }
  }
};
